import { render } from "./label-list.vue?vue&type=template&id=1878805d&scoped=true"
import script from "./label-list.vue?vue&type=script&lang=js"
export * from "./label-list.vue?vue&type=script&lang=js"

import "./label-list.vue?vue&type=style&index=0&id=1878805d&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1878805d"]])

export default __exports__